export default "__VITE_ASSET__a14db22d__"